import React from 'react';
import './ErrorBoundary.module.scss';
import * as Sentry from '@sentry/react';
import Layout from '../Layout';

export default function ErrorBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Sentry.ErrorBoundary
      fallback={() => (
        <Layout>
          <div styleName="error-screen">
            <div styleName="wrapper">
              <img src="/images/404.svg" alt="404" />
              <h2>Oops!!</h2>
              <p>
                Groow lijkt de pagina die je zoekt even niet te kunnen vinden.
                Ga terug naar de startpagina om snel verder te ontwerpen.
              </p>
            </div>
          </div>
        </Layout>
      )}
      dialogOptions={{
        lang: 'nl',
        title: 'Er ging iets mis.',
        subtitle:
          'We zijn automatisch op de hoogte gebracht van dit probleem. Als je wilt helpen, laat ons dan hieronder weten wat er precies gebeurde.',
        subtitle2: '',
        labelName: 'Naam',
        labelEmail: 'Email',
        labelComments: 'Beschrijf wat er gebeurde',
        labelClose: 'Sluiten',
        labelSubmit: 'Versturen',
        successMessage:
          'Bedankt voor je feedback, we proberen het probleem zo snel mogelijk op te lossen!',
        errorFormEntry:
          'Niet alle velden zijn correct ingevuld, probeer alstublieft opnieuw',
        errorGeneric: 'Het is niet gelukt de melding te versturen',
      }}
      showDialog
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
